import React from 'react';
import './ProfilePage.css'; // Стили для страницы профиля
// import PayButton from '../components/PaymentButton';
import { useSelector } from 'react-redux'; // Импортируем useSelector

const ProfilePage = ({ initData }) => { // Сохраняем initData в пропсах
  const subscriptionData = useSelector(state => state.subscriptionData); // Получаем данные о подписке из Redux
  
  if (!subscriptionData) {
    return <div>Загрузка...</div>; // Если данные еще не загружены
  }

  const {
    subscription_active,
    subscription_expiry,
    referral_code,
    // referral_count
  } = subscriptionData;

  const copyLink = () => {
    const inviteLink = `https://t.me/chuvak_signals_bot?startapp=${referral_code}`;
    navigator.clipboard.writeText(inviteLink);
    alert("Ссылка скопирована");
  };

  const shareLink = () => {
    const inviteLink = `https://t.me/chuvak_signals_bot?startapp=${referral_code}`;
    const shareText = 'Глянь, крутой сканер для арбитража';
    const fullUrl = `https://t.me/share/url?url=${encodeURIComponent(inviteLink)}&text=${shareText}`;
    window.open(fullUrl, '_blank');
  };

  return (
    <div className="profile-page">
      <h1>Профиль</h1>

      <div className="profile-page__wrapper">
        <div className="user-wrapper">
          {window.Telegram?.WebApp?.initDataUnsafe?.user?.photo_url && (
            <img className="user-avatar" src={window.Telegram.WebApp.initDataUnsafe.user.photo_url} alt="" />
          )}

          <div className="user-info">
            {window.Telegram?.WebApp?.initDataUnsafe?.user?.first_name && (
              <span className="user-name">{window.Telegram.WebApp.initDataUnsafe.user.first_name}</span>
            )}

            <div className="profile-item">
              {subscription_active ? <span>Статус подписки:</span> : ''}
            </div>

            {/* {subscription_active && ( */}
              <>
                <div className="profile-item">
                  <strong>{subscription_active ? 'Активна до ' : 'Подписка неактивна'}</strong>
                  {subscription_active ? <strong>{new Date(subscription_expiry).toLocaleDateString()}</strong> : ''}
                </div>
              </>
            {/* )} */}

            {/* <div className="profile-pay-button">
              <PayButton initData={initData}/>
            </div> */}
            <div className="help-and-payment">
              <a href='https://metod-payscanner.ru/#oplata' target='_blank' rel='noreferrer' className="link-btn link-guide">Продлить</a>
            </div>
          </div>
        </div>

        <div className="profile-renc">
        </div>
        

        <div className="referral-program">
          <p>Реферальная программа</p>
          <span>Ваша реферальная ссылка:</span>
          <div className="profile-buttons">
            <button className="referral-program-link">{`t.me/chuvak_signals_bot?startapp=${referral_code}`}</button>
            <button onClick={copyLink}>Скопировать</button>
            <button className="referral-program-share" onClick={shareLink}>
              <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 13 13" fill="none">
                <path d="M2.16699 6.5V10.8333C2.16699 11.1207 2.28113 11.3962 2.48429 11.5994C2.68746 11.8025 2.96301 11.9167 3.25033 11.9167H9.75033C10.0376 11.9167 10.3132 11.8025 10.5164 11.5994C10.7195 11.3962 10.8337 11.1207 10.8337 10.8333V6.5" stroke="white" strokeWidth="1.08333" strokeLinecap="round" strokeLinejoin="round"/>
                <path d="M8.66634 3.25016L6.49967 1.0835L4.33301 3.25016" stroke="white" strokeWidth="1.08333" strokeLinecap="round" strokeLinejoin="round"/>
                <path d="M6.5 1.0835V8.12516" stroke="white" strokeWidth="1.08333" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </button>
          </div>
        </div>

        <div className="profile-renc">
        </div>

        {/* <div className="help-and-payment">
          <img src="/images/pay_error.png" alt="Ошибка оплаты" />
          <div>
            <p>Проблемы с оплатой?<br/>Свяжись с нами!</p>
            <a href='https://t.me/chuvak_arbitrazh' className="link-btn link-guide">Связаться</a>
          </div>
        </div> */}
      </div>

      <div className="profile-page__wrapper">
        <div className="help-and-payment">
          <img src="/images/pay_error.png" alt="Ошибка оплаты" />
          <div>
            <p>Проблемы с оплатой?<br/>Свяжись с нами!</p>
            <a href='https://t.me/chuvak_arbitrazh' className="link-btn link-guide">Связаться</a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProfilePage;
